import React, { createContext, useContext, ReactNode } from "react";
import { useQuery } from "@apollo/client";
import { ME_QUERY } from "../api/user-queries";
import { User } from "../__generated__/graphql";

interface UserContextType {
  user: User | null;
  loading: boolean;
  error: any;
  refetch: () => void;
}

const UserContext = createContext<UserContextType | undefined>(undefined);

/**
 * NOTE: 유저의 name이 null일 경우에는 따로 처리를 해주어야 합니다.
 */
export const UserProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const { data, loading, error, refetch } = useQuery(ME_QUERY, {
    skip: !localStorage.getItem("jwt"),
    fetchPolicy: "cache-first",
  });

  const value = {
    user: data?.me || null,
    loading,
    error,
    refetch,
  };

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};

export const useUser = () => {
  const context = useContext(UserContext);
  if (context === undefined) {
    throw new Error("useUser must be used within a UserProvider");
  }
  return context;
};
